import { Card, Row, Col, Typography, Tooltip } from "antd";
import { InboxOutlined, ShoppingOutlined, TeamOutlined, AppstoreOutlined } from "@ant-design/icons";

const { Text } = Typography;

const formatNumber = (num) =>
  new Intl.NumberFormat("es-CO").format(Number(num || 0));

const formatCompact = (num) => {
  if (num >= 1000000000) return (num / 1000000000).toFixed(1) + "B";
  if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
  if (num >= 1000) return (num / 1000).toFixed(1) + "K";
  return num;
};

export default function EntregasCards({ stats }) {

  const metrics = {
    totalEntregas: Number(stats?.total_lineas || 0),
    totalCantidad: Number(stats?.total_cantidad || 0),
    totalParticipantes: Number(stats?.total_beneficiarios || 0),
    totalProductos: Number(stats?.total_productos || 0)
  };

  const cards = [
    {
      title: "Total entregas",
      value: metrics.totalEntregas,
      description: "Número total de entregas registradas en el sistema",
      icon: <InboxOutlined />,
      color: "#1677ff"
    },
    {
      title: "Cantidad entregada",
      value: metrics.totalCantidad,
      description: "Cantidad total de unidades entregadas",
      icon: <ShoppingOutlined />,
      color: "#52c41a"
    },
    {
      title: "Participantes",
      value: metrics.totalParticipantes,
      description: "Participantes únicos que recibieron productos",
      icon: <TeamOutlined />,
      color: "#fa8c16"
    },
    {
      title: "Productos distintos",
      value: metrics.totalProductos,
      description: "Número de productos diferentes entregados",
      icon: <AppstoreOutlined />,
      color: "#722ed1"
    }
  ];

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      {cards.map((card, index) => (
        <Col xs={24} sm={12} lg={6} key={index}>
          <Card
            hoverable
            bordered={false}
            style={{
              borderRadius: 12,
              padding: 14,
              boxShadow: "0 3px 10px rgba(0,0,0,0.06)",
              transition: "all .2s"
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <div>
                <Text
                  style={{
                    color: "#6b7280",
                    fontSize: 13,
                    display: "block",
                    marginBottom: 6
                  }}
                >
                  {card.title}
                </Text>
                <Tooltip
                  title={`${card.description}: ${formatNumber(card.value)}`}
                >
                  <div
                    style={{
                      fontSize: 26,
                      fontWeight: 700,
                      color: "#111827",
                      cursor: "help"
                    }}
                  >
                    {formatCompact(card.value)}
                  </div>
                </Tooltip>
              </div>
              <div
                style={{
                  background: card.color + "20",
                  color: card.color,
                  width: 48,
                  height: 48,
                  borderRadius: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 22
                }}
              >
                {card.icon}
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
}